export default {
  values: {
    "webhook must not be empty": "webhook must not be empty",
    "defaultChannel must not be empty": "defaultChannel must not be empty",
    Webhook: "Webhook",
    "Default Channel": "Default Channel",
  },
};
